import {
  DEFAULT_QUERY_SETTING,
  PAGINATION_LIMIT_8,
  PAGINATION_PAGE,
} from "@/constants/variables";
import { IAgentData } from "@/interfaces/IAgentData";
import { IResponseFormat } from "@/interfaces/IHelper";
import useProfileStore from "@/stores/profile";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { getMyAgents } from "@/features/myAgent/service/MyAgent.services";
import { useDebounceCallback } from "usehooks-ts";
import { FILTER_MENU } from "@/constants/menu";
import { IGetMyAgent } from "@/features/myAgent/interface/IGetListMyAgent";

const useMyAgents = () => {
  const [myAgents, setMyAgents] = useState<
    IResponseFormat<IAgentData[]> | undefined
  >(undefined);
  const token = useProfileStore((state) => state.token);
  const [limit, setLimit] = useState<number>(PAGINATION_LIMIT_8);
  const [page, setPage] = useState<number>(PAGINATION_PAGE);
  const [publishStatus, setPublishStatus] = useState<string>(FILTER_MENU[0].id);
  const [search, _] = useState<string>("");
  const setSearch = useDebounceCallback(_, 1000);

  const {
    data,
    isLoading: isLoadingAgent,
    refetch: refetchAgent,
  } = useQuery({
    queryKey: ["getMyAgents", token, limit, page, search, publishStatus],
    queryFn: async () => {
      let publish_status: IGetMyAgent["publish_status"];

      if (publishStatus !== FILTER_MENU[0].id) {
        publish_status = publishStatus as IGetMyAgent["publish_status"];
      }

      const params: IGetMyAgent = {
        limit,
        page,
        sort: 1,
        search: search,
        search_option: "name",
        is_active: true,
        skip: 0,
        tags: [],
        publish_status,
        token: token ? token.token : "",
      };
      return getMyAgents(params);
    },
    ...DEFAULT_QUERY_SETTING,
    enabled: !!token?.token,
    gcTime: 0,
  });

  const getList = useCallback(() => {
    if (data) {
      setMyAgents(data);
    }
    if (data?.info?.currentCount === 0) {
      setPage(data.info.prevPage || 1);
    }
  }, [data]);

  useEffect(() => {
    let cancel = false;
    if (!cancel) {
      getList();
    }
    return () => {
      cancel = true;
    };
  }, [data, getList]);

  return {
    myAgents,
    isLoadingAgent,
    refetchAgent,
    setLimit,
    setPage,
    search,
    setSearch,
    publishStatus,
    setPublishStatus,
  };
};

export default useMyAgents;
